var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-product-card"
  }, [_vm._l(_vm.topCustomField, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "product-card-custom-field"
    }, [_c('div', {
      staticClass: "custom-field-line"
    }, [item.name ? _c('div', {
      staticClass: "order-name"
    }, [_vm._v(" " + _vm._s(item.name) + ": ")]) : _vm._e(), _c('div', {
      staticClass: "order-value"
    }, [_vm._v(" " + _vm._s(item.value) + " ")])])]);
  }), _c('div', {
    staticClass: "product-card-main"
  }, [_vm.props.payload.content.pic ? _c('img', {
    staticClass: "product-img",
    attrs: {
      "src": _vm.props.payload.content.pic
    }
  }) : _vm._e(), _c('div', {
    staticClass: "product-card-information"
  }, [_c('div', {
    staticClass: "product-card-title"
  }, [_vm._v(" " + _vm._s(_vm.props.payload.content.header) + " ")]), _c('div', {
    staticClass: "product-card-description-block"
  }, [_c('div', {
    staticClass: "product-card-description"
  }, [_vm._v(" " + _vm._s(_vm.props.payload.content.desc) + " ")])])])]), _vm._l(_vm.bottomCustomField, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "product-card-custom-field"
    }, [_c('div', {
      staticClass: "custom-field-line"
    }, [item.name ? _c('div', {
      staticClass: "order-name"
    }, [_vm._v(" " + _vm._s(item.name) + ": ")]) : _vm._e(), _c('div', {
      staticClass: "order-value"
    }, [_vm._v(" " + _vm._s(item.value) + " ")])])]);
  }), _c('div', {
    staticClass: "product-card-link",
    on: {
      "click": _vm.jumpProductCard
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.跳转")) + " ")])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }